import { Metadata } from '@redwoodjs/web';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';

export default function AutomationSettingsPage() {
  return (
    <>
      <Metadata title="Automation Settings" />
      <PageHeader pageType={PageType.AutomationSettings}></PageHeader>
      <PageBody>todo</PageBody>
    </>
  );
}
